var locatorLoaderPromise = null;
var defaultSearchLocation = { lat: 54, lng: -2 };
var $ = window.jQuery;

function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps) {
        return $.Deferred().resolve().promise();
    }

    if (locatorLoaderPromise) {
        return locatorLoaderPromise.promise();
    }

    locatorLoaderPromise = $.Deferred();

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey);
    script.onload = function () {
        locatorLoaderPromise.resolve();
    };
    script.onerror = function () {
        locatorLoaderPromise.reject(new Error('Google Maps could not be loaded.'));
    };

    document.head.appendChild(script);

    return locatorLoaderPromise.promise();
}

function getDataId(root, key) {
    return root.getAttribute('data-' + key);
}

function setMessage(messageElement, text, isError) {
    if (!messageElement) {
        return;
    }

    messageElement.classList.toggle('text-red-300', !!isError);
    messageElement.classList.toggle('text-white/80', !isError);
    messageElement.textContent = text || '';
}

function clearMarkers(markers) {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }

    markers.length = 0;
}

function renderAddress(address, className) {
    var wrapper = document.createElement('div');
    wrapper.className = className || 'text-sm text-white/70';

    if (!address) {
        return wrapper;
    }

    var lines = address.split(/\r?\n|,/);
    for (var i = 0; i < lines.length; i++) {
        var line = lines[i].replace(/^\s+|\s+$/g, '');

        if (!line) {
            continue;
        }

        if (wrapper.childNodes.length > 0) {
            wrapper.appendChild(document.createElement('br'));
        }

        wrapper.appendChild(document.createTextNode(line));
    }

    return wrapper;
}

function createClinicInfoWindowContent(clinic) {
    var wrapper = document.createElement('div');
    wrapper.className = 'w-[270px] max-w-[270px] rounded-xl bg-white px-4 pb-4 pt-2 text-slate-900';

    var title = document.createElement('div');
    title.className = 'mb-2 pr-12 text-lg font-semibold leading-snug text-[#002C00]';
    title.textContent = clinic.Name || clinic.name || 'Clinic';
    wrapper.appendChild(title);

    var distanceValue = clinic.Distance || clinic.distance;
    if (distanceValue !== undefined && distanceValue !== null) {
        var distance = document.createElement('div');
        distance.className = 'mb-3 inline-flex rounded-full bg-[#f6f7f4] px-3 py-1 text-sm font-medium leading-none text-slate-600';
        distance.textContent = distanceValue + ' ' + (clinic.Units || clinic.units || 'miles') + ' away';
        wrapper.appendChild(distance);
    }

    var address = clinic.Address || clinic.address;
    if (address) {
        wrapper.appendChild(renderAddress(address, 'mb-3 block whitespace-normal text-sm leading-[1] text-slate-700 break-words'));
    }

    var clinicUrl = clinic.Url || clinic.url;
    if (clinicUrl) {
        var link = document.createElement('a');
        link.className = 'inline-flex mt-10 items-center text-sm font-semibold leading-none text-[#002C00] underline underline-offset-4 transition-colors duration-200 hover:text-[#FCAD99]';
        link.href = clinicUrl;
        link.textContent = 'View clinic';
        wrapper.appendChild(link);
    }

    return wrapper;
}

function ajaxJson(url, data) {
    var deferred = $.Deferred();
    var query = [];

    for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key) && data[key] !== undefined && data[key] !== null) {
            query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
    }

    var requestUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + query.join('&');
    var request = new XMLHttpRequest();

    request.open('GET', requestUrl, true);
    request.setRequestHeader('Accept', 'application/json');
    request.onreadystatechange = function () {
        if (request.readyState !== 4) {
            return;
        }

        if (request.status >= 200 && request.status < 300) {
            try {
                deferred.resolve(JSON.parse(request.responseText));
            } catch (error) {
                deferred.reject(error);
            }
        } else {
            deferred.reject(new Error('Request failed with status ' + request.status));
        }
    };

    request.send(null);

    return deferred.promise();
}

function createFlatMarkerIcon(fillColor, outlineColor) {
    var size = 45;
    var anchorY = 45;
    var anchorX = Math.round(size / 2);
    var strokeAttribute = outlineColor ? ' stroke="' + outlineColor + '" stroke-width="1.2" vector-effect="non-scaling-stroke"' : '';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="' + fillColor + '"' + strokeAttribute + ' d="M12 2C8.13 2 5 5.13 5 9c0 4.95 7 13 7 13s7-8.05 7-13c0-3.87-3.13-7-7-7zm0 10.2A3.2 3.2 0 1 1 12 5.8a3.2 3.2 0 0 1 0 6.4z"/></svg>';
    var icon = {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(size, size),
        anchor: new google.maps.Point(anchorX, anchorY),
        fillColor: fillColor,
        outlineColor: outlineColor || null
    };

    return icon;
}

function initMap(root) {
    var mapId = getDataId(root, 'map-id');
    var mapElement = document.getElementById(mapId);

    return new google.maps.Map(mapElement, {
        center: defaultSearchLocation,
        zoom: 6,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        styles: [
            { elementType: 'geometry', stylers: [{ color: '#f3f0ec' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#002c00' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#f3f0ec' }] },
            { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#fcad99' }] },
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ddd8d3' }] },
            { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#667066' }] },
            { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e4e8ea' }] },
            { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#6b7c83' }] }
        ]
    });
}

function initClinicLocator(root) {
    var apiKey = getDataId(root, 'google-maps-api-key') || '';
    var endpointUrl = getDataId(root, 'endpoint') || '';
    var formId = getDataId(root, 'form-id');
    var postcodeId = getDataId(root, 'postcode-id');
    var messageId = getDataId(root, 'message-id');
    var searchButtonId = getDataId(root, 'search-button-id');
    var maxResults = parseInt(getDataId(root, 'max-results') || '5', 10);
    var clinicIds = getDataId(root, 'clinic-ids') || '';

    var form = document.getElementById(formId);
    var postcode = document.getElementById(postcodeId);
    var message = document.getElementById(messageId);
    var button = document.getElementById(searchButtonId);
    var map = null;
    var geocoder = null;
    var markers = [];

    if (!form || !postcode || !message || !button) {
        return;
    }

    function addMarker(position, title, icon, content) {
        var marker = new google.maps.Marker({
            position: position,
            map: map,
            title: title,
            icon: icon || null
        });

        if (content) {
            var infoWindow = new google.maps.InfoWindow({
                content: content
            });

            marker.addListener('click', function () {
                infoWindow.open(map, marker);
            });
        }

        markers.push(marker);
        return marker;
    }

    function renderMap(searchLocation, clinics, locationLabel) {
        clearMarkers(markers);

        var bounds = new google.maps.LatLngBounds();
        bounds.extend(searchLocation);

        if (clinics && clinics.length) {
            for (var i = 0; i < clinics.length; i++) {
                var clinic = clinics[i];
                var latitude = clinic.Latitude || clinic.latitude;
                var longitude = clinic.Longitude || clinic.longitude;

                if (latitude === undefined || longitude === undefined || latitude === null || longitude === null) {
                    continue;
                }

                var position = new google.maps.LatLng(latitude, longitude);
                bounds.extend(position);
                addMarker(position, clinic.Name || clinic.name || 'Clinic', createFlatMarkerIcon('#002C00', '#002C00'), createClinicInfoWindowContent(clinic));
            }

            map.fitBounds(bounds, 80);
            var currentZoom = map.getZoom();
            if (currentZoom > 8) {
                map.setZoom(8);
            }
        } else {
            map.setCenter(searchLocation);
            map.setZoom(8);
        }
    }

    function fetchClinicsByLocation(searchLocation, locationLabel, loadingMessage, successMessage, noResultsMessage, shouldScrollToMap) {
        button.disabled = true;
        setMessage(message, loadingMessage || 'Looking up nearby clinics...', false);

        ajaxJson(endpointUrl, {
            latitude: searchLocation.lat(),
            longitude: searchLocation.lng(),
            units: 'miles',
            count: maxResults,
            clinicIds: clinicIds
        }).done(function (clinics) {
            renderMap(searchLocation, clinics, locationLabel);

            if (clinics && clinics.length) {
                setMessage(message, successMessage || 'Showing the nearest clinics.', false);

                if (shouldScrollToMap) {
                    var mapElement = map && map.getDiv ? map.getDiv() : null;
                    if (mapElement && mapElement.scrollIntoView) {
                        mapElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            } else {
                setMessage(message, noResultsMessage || 'No clinics were found near that location.', true);
            }
        }).fail(function () {
            setMessage(message, 'Unable to load clinic results right now.', true);
        }).always(function () {
            button.disabled = false;
        });
    }

    function searchClinics() {
        var postcodeValue = postcode.value.replace(/^\s+|\s+$/g, '');

        if (!postcodeValue) {
            setMessage(message, 'Enter a postcode to search.', true);
            return;
        }

        if (!apiKey && !(window.google && window.google.maps)) {
            setMessage(message, 'Google Maps API key is not configured.', true);
            return;
        }

        button.disabled = true;
        setMessage(message, 'Looking up nearby clinics...', false);

        loadGoogleMaps(apiKey).done(function () {
            if (!map) {
                map = initMap(root);
                geocoder = new google.maps.Geocoder();
            }

            geocoder.geocode({ address: postcodeValue + ', UK' }, function (geocodeResults, status) {
                if (status !== google.maps.GeocoderStatus.OK || !geocodeResults || !geocodeResults.length) {
                    setMessage(message, 'Could not find that postcode.', true);
                    button.disabled = false;
                    return;
                }

                var searchLocation = geocodeResults[0].geometry.location;
                fetchClinicsByLocation(searchLocation, 'Your postcode', 'Looking up nearby clinics...', 'Showing the nearest clinics.', 'No clinics were found near that postcode.', true);
            });
        }).fail(function () {
            setMessage(message, 'Google Maps could not be loaded.', true);
            button.disabled = false;
        });
    }

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        searchClinics();
    });

    if (!apiKey && !(window.google && window.google.maps)) {
        setMessage(message, 'Google Maps API key is not configured.', true);
        button.disabled = true;
        return;
    }

    function initializeDefaultSearch() {
        var defaultLocation = new google.maps.LatLng(defaultSearchLocation.lat, defaultSearchLocation.lng);
        fetchClinicsByLocation(defaultLocation, 'Default location', 'Looking up nearby clinics...', 'Showing the nearest clinics.', 'No clinics were found near the default location.');
    }

    loadGoogleMaps(apiKey).done(function () {
        if (!map) {
            map = initMap(root);
            geocoder = new google.maps.Geocoder();
        }

        initializeDefaultSearch();
    }).fail(function () {
        setMessage(message, 'Google Maps could not be loaded.', true);
    });
}

export function initClinicLocatorBlocks() {
    if (!$) {
        return;
    }

    var locatorRoots = document.querySelectorAll('[data-clinic-locator="true"]');
    Array.prototype.forEach.call(locatorRoots, function (root) {
        initClinicLocator(root);
    });
}

